import { Grid, Typography } from "@mui/material";

import DatePicker from "components/DatePicker";
import Select from "components/Select";
import { useFormContext } from "react-hook-form";

function FilterActivities({ loginActivityForm }) {
  const { watch, setValue } = useFormContext();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="label" color="text.secondary">
          From Date
        </Typography>

        <DatePicker
          value={watch("startDate")}
          onChange={(e) => {
            setValue("startDate", e);
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="label" color="text.secondary">
          To Date
        </Typography>

        <DatePicker
          value={watch("endDate")}
          onChange={(e) => {
            setValue("endDate", e);
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="label" color="text.secondary">
          Type
        </Typography>

        <Select
          value={watch("typeId")}
          onChange={(e) => {
            setValue("typeId", e.target.value);
          }}
          dir="ltr"
          itemText="name"
          itemValue="id"
          items={loginActivityForm?.lisType}
        />
      </Grid>
    </Grid>
  );
}

export default FilterActivities;
